import moment from 'moment'

export const DATE_FORMAT_FULL_DAY = 'MMMM D, YYYY'

export default (date, format = DATE_FORMAT_FULL_DAY) => moment(date).format(format)
